<template>
  <component
    v-on="$listeners"
    :is="component"
    :item="item"
    :send-event="sendEvent"
    class="search-result"
  />
</template>

<script>
import CardBlog from './CardBlog.vue';
import CardImage from './CardImage.vue';
import CardPage from './CardPage.vue';
import CardProduct from './CardProduct.vue';
import CardPart from './CardPart.vue';
import CardResource from './CardResource.vue';
import CardSpec from './CardSpec.vue';
import CardVideo from './CardVideo.vue';

const components = {
  blog: CardBlog,
  images: CardImage,
  inspiration: CardPage,
  pages: CardPage,
  products: CardProduct,
  parts: CardPart,
  resources: CardResource,
  specs: CardSpec,
  videos: CardVideo
};

export default {
  props: ['item', 'sendEvent'],
  computed: {
    component() {
      return components[this.type];
    },
    type() {
      return this.item.search_tag.toLowerCase();
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/system';
@import '../../../scss/mixins';

.search-result {
  position: relative;

  h3 {
    font-size: 1.6rem;
    font-weight: $font-weight-medium;
    line-height: 1.35;
    margin: 0 0 0.33em 0;
  }

  .responsive-image:before {
    content: '';
    display: block;
    width: 100%;
    padding-bottom: 62.5%;
  }

  &:hover a {
    color: $color-blue-400;
  }

  a {
    color: $color-black;
  }

  a:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  &-pill {
    display: inline-block;
    align-self: flex-start;
    text-transform: uppercase;
    font-size: 1.2rem;
    font-weight: $font-weight-medium;
    padding: 0.333em 0.667em;
    letter-spacing: 0.01em;
    white-space: nowrap;
    border-radius: 3px;
    background-color: $color-gray-200;
    color: $color-black;
  }

  .ais-Highlight mark {
    font-style: normal;
    background-color: $color-highlight;
  }
}
</style>
